// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as SterlingForms$LiveRoom from "../bindings/SterlingForms.bs.js";
import * as Form from "@sothebys/sterling/form";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

var SelectStringSelect = SterlingForms$LiveRoom.Select.MakeSelect({});

var titleStyle = Curry._1(Css.style, {
      hd: Css.transition(StyleConstants$LiveRoom.animationSlow, undefined, Css.easeOut, "color"),
      tl: /* [] */0
    });

var valueStyle = Curry._1(Css.style, {
      hd: Css.transition(StyleConstants$LiveRoom.animationFast, undefined, Css.easeOut, "background-color"),
      tl: /* [] */0
    });

var labelStyle = Curry._1(Css.style, {
      hd: Css.width(Css.pct(100)),
      tl: {
        hd: Css.paddingRight(Css.px(8)),
        tl: {
          hd: Css.whiteSpace("nowrap"),
          tl: {
            hd: Css.textOverflow("ellipsis"),
            tl: {
              hd: Css.overflow("hidden"),
              tl: /* [] */0
            }
          }
        }
      }
    });

function shouldShowCustomButton(value) {
  if (value.TAG === /* Placeholder */0) {
    return false;
  } else {
    return value._0.address.length > 0;
  }
}

function SelectString$CustomSelectComponents$ButtonComponent(props) {
  var value = props.value;
  var match = shouldShowCustomButton(value);
  if (!match) {
    return null;
  }
  if (value.TAG === /* Placeholder */0) {
    return null;
  }
  var accountInfo = value._0;
  if (accountInfo.address.length > 0) {
    return React.createElement(PropSpread$LiveRoom.make, {
                data: {
                  hd: {
                    TAG: /* TestId */1,
                    _0: "selectAccountButton"
                  },
                  tl: /* [] */0
                },
                children: React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.width(Css.pct(100)),
                            tl: /* [] */0
                          })
                    }, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                          className: labelStyle,
                          children: accountInfo.holderName
                        }), React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                          className: labelStyle,
                          children: accountInfo.address
                        }))
              });
  } else {
    return null;
  }
}

var ButtonComponent = {
  make: SelectString$CustomSelectComponents$ButtonComponent
};

function SelectString$CustomSelectComponents$ItemComponent(props) {
  var item = props.item;
  var address = item.address;
  if (address.length > 0) {
    return React.createElement(PropSpread$LiveRoom.make, {
                data: {
                  hd: {
                    TAG: /* TestId */1,
                    _0: "selectAccountItem"
                  },
                  tl: /* [] */0
                },
                children: React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.width(Css.pct(100)),
                            tl: {
                              hd: Css.height(Css.px(80)),
                              tl: {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.alignItems("center"),
                                  tl: {
                                    hd: Css.flexWrap("wrap"),
                                    tl: {
                                      hd: Css.alignContent("center"),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          })
                    }, React.createElement(PropSpread$LiveRoom.make, {
                          data: {
                            hd: {
                              TAG: /* TestId */1,
                              _0: "holderNameLabel"
                            },
                            tl: /* [] */0
                          },
                          children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                                className: labelStyle,
                                children: item.holderName
                              })
                        }), React.createElement(PropSpread$LiveRoom.make, {
                          data: {
                            hd: {
                              TAG: /* TestId */1,
                              _0: "address"
                            },
                            tl: /* [] */0
                          },
                          children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                                className: labelStyle,
                                children: item.address
                              })
                        }))
              });
  } else {
    return React.createElement("div", {
                className: Curry._1(Css.style, {
                      hd: Css.width(Css.pct(100)),
                      tl: /* [] */0
                    })
              }, React.createElement(PropSpread$LiveRoom.make, {
                    data: {
                      hd: {
                        TAG: /* TestId */1,
                        _0: "holderName"
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                          className: labelStyle,
                          children: item.holderName
                        })
                  }));
  }
}

var ItemComponent = {
  make: SelectString$CustomSelectComponents$ItemComponent
};

var CustomSelectComponents = {
  shouldShowCustomButton: shouldShowCustomButton,
  ButtonComponent: ButtonComponent,
  ItemComponent: ItemComponent
};

function SelectString(props) {
  var mayShowTitle = props.mayShowTitle;
  var title = props.title;
  var onSelect = props.onSelect;
  var value = props.value;
  var title$1 = title !== undefined ? title : "";
  var mayShowTitle$1 = mayShowTitle !== undefined ? mayShowTitle : true;
  var selected;
  if (value.TAG === /* Placeholder */0) {
    selected = undefined;
  } else {
    var accountInfo = value._0;
    selected = {
      label: accountInfo.holderName,
      value: accountInfo.id
    };
  }
  var handleSelect = function (item) {
    Curry._1(onSelect, [
          item.value,
          item.label
        ]);
  };
  var tmp;
  tmp = value.TAG === /* Placeholder */0 || value._0.address.length <= 0 ? "normal" : "large";
  var tmp$1 = title$1 === "" ? undefined : title$1;
  return React.createElement("div", undefined, title$1 !== "" && mayShowTitle$1 ? React.createElement("span", {
                    className: titleStyle
                  }, title$1) : null, React.createElement(Form.Select, {
                  children: React.createElement(SelectStringSelect.Menu.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.overflow(Css.scroll),
                              tl: {
                                hd: Css.maxHeight(Css.px(448)),
                                tl: /* [] */0
                              }
                            }),
                        children: Belt_Array.mapWithIndex(props.itemList, (function (index, item) {
                                var match = item.holderName;
                                var match$1 = item.address;
                                return JsxPPXReactSupport.createElementWithKey("item-" + (item.id + String(index)), Form.Select.Item, {
                                            label: match$1.length > 0 ? match + (", " + match$1) : match,
                                            id: "item-" + (item.id + String(index)),
                                            className: valueStyle,
                                            itemComponent: Caml_option.some(React.createElement(SelectString$CustomSelectComponents$ItemComponent, {
                                                      item: item
                                                    })),
                                            value: item.id
                                          });
                              }))
                      }),
                  name: props.name,
                  size: tmp,
                  className: Curry._1(Css.style, {
                        hd: Css.selector("> li", {
                              hd: Css.focus(CommonStyles$LiveRoom.buttonFocus),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }),
                  placeholder: tmp$1,
                  selected: selected,
                  showSubLabel: true,
                  onValueChange: handleSelect,
                  useNativeSelectOnMobile: false,
                  buttonComponent: shouldShowCustomButton(value) ? Caml_option.some(React.createElement(SelectString$CustomSelectComponents$ButtonComponent, {
                              value: value
                            })) : undefined
                }));
}

var make = SelectString;

export {
  SelectStringSelect ,
  titleStyle ,
  valueStyle ,
  labelStyle ,
  CustomSelectComponents ,
  make ,
}
/* SelectStringSelect Not a pure module */
